var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      directives: [
        { name: "show", rawName: "v-show", value: true, expression: "true" }
      ],
      attrs: { fluid: "" }
    },
    [
      _c(
        "div",
        { attrs: { align: "left" } },
        [
          _c("v-flex", [
            _c(
              "h2",
              {
                staticClass: "h2_title",
                staticStyle: { "margin-top": "12px !important" }
              },
              [_vm._v("Sim Cards")]
            )
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "", layout: "" } },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md12: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btnPlantilla",
                          attrs: { flat: "", small: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.descargarPlantilla("PENDIENTES")
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("  \n            "),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Descargar Plantilla")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md12: "", layout: "" } },
                    [
                      _c("p", { staticClass: "aclaracion" }, [
                        _vm._v(
                          "\n            Utilice el formato de la siguiente plantilla para evitar\n            conflictos al momento de cargar la solicitud.\n          "
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex xs6 sm6 md6" },
                [
                  _c("v-text-field", {
                    attrs: {
                      xs3: "",
                      sm3: "",
                      md3: "",
                      label: "Seleccione archivo para carga masiva",
                      heigh: "",
                      "error-messages": _vm.errors.collect("archivo"),
                      "data-vv-name": "archivo",
                      readonly: "readonly"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$refs.image.click()
                      }
                    },
                    model: {
                      value: _vm.fileName,
                      callback: function($$v) {
                        _vm.fileName = $$v
                      },
                      expression: "fileName"
                    }
                  }),
                  _c("input", {
                    ref: "image",
                    staticStyle: { display: "none" },
                    attrs: {
                      type: "file",
                      accept: ".xlsx, .xls",
                      clearable: "",
                      id: "archivoExcel"
                    },
                    on: { change: _vm.prepare_file_upload }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex xs2 sm2 md2" },
                [
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.fileName,
                          expression: "fileName"
                        }
                      ],
                      staticStyle: { "margin-top": "10px" },
                      on: { click: _vm.quitarRegistro }
                    },
                    [_vm._v("✖")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex xs2 sm2 md2" },
                [
                  false
                    ? _c(
                        "v-btn",
                        {
                          staticClass:
                            "btn-sucursal btn-cargar v-btn theme--light",
                          staticStyle: { "margin-top": "10px" },
                          attrs: { disabled: _vm.errorArchivo },
                          on: { click: _vm.cargar }
                        },
                        [
                          _c("v-icon", [_vm._v("attach_file")]),
                          _vm._v("Cargar\n        ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-layout",
            { staticClass: "ml-5", attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", sm4: "", md4: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Buscar", outlined: "" },
                    on: {
                      keyup: function($event) {
                        return _vm.gridApi.setQuickFilter(_vm.filtro)
                      }
                    },
                    model: {
                      value: _vm.filtro,
                      callback: function($$v) {
                        _vm.filtro = $$v
                      },
                      expression: "filtro"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { xs3: "", sm8: "", md8: "" } }, [
                _c(
                  "div",
                  {
                    staticStyle: { "padding-top": "6px" },
                    attrs: { align: "right" }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticStyle: { "padding-right": "20px" },
                        attrs: {
                          color: "#ffe800",
                          disabled: !_vm.errorArchivo
                        },
                        on: {
                          click: function($event) {
                            return _vm.cargarSimTodas()
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticStyle: { color: "black" },
                            attrs: { dark: "", left: "" }
                          },
                          [_vm._v("add_circle_outline")]
                        ),
                        _c("span", { staticStyle: { color: "black" } }, [
                          _vm._v("Agregar Sim Cards")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            { staticClass: "tablaSimsSelected" },
            [
              _c("MantenedorGridSinCodigo", {
                staticClass: "ag-theme-material",
                staticStyle: { "font-family": "'Asap', sans-serif" },
                attrs: {
                  gridOptions: _vm.gridOptions,
                  funcionalidadId: _vm.funcionalidad
                }
              })
            ],
            1
          ),
          _vm.verTodasSims
            ? _c("TodasSims", {
                ref: "TodasSims",
                attrs: {
                  DispositivosTotalesSim: _vm.verTodasSims,
                  idsSims: _vm.idsSims,
                  dataSelected: _vm.dataSelected
                },
                on: {
                  DispositivosTotalesSim: function($event) {
                    _vm.verTodasSims = $event
                  },
                  selected: function($event) {
                    return _vm.cargarSelected($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }